<info-box>
    <ng-container *ngIf="isSelfAdvertising">
        <p> Kampanie w usłudze Retail Media Network są realizowane na zasadzie aukcji. Jako partner, emitując kampanię
            na swojej przestrzeni, wystarczy, że określisz żądaną liczbę wyświetleń i czas trwania kampanii. Jeżeli
            zewnętrzni producenci zlecają w Retail Media Network kampanie, które mogą przynieść Ci dodatkowe dochody,
            mogą one zastąpić Twoją kampanię, maksymalizując tym samym Twoje przychody z współpracy. </p>
    </ng-container>
    <ng-container *ngIf="!isSelfAdvertising">
        <h6>Jak działa budżet i limity?</h6>
        <p> Kampanie w usłudze Retail Media Network są emitowane w modelu aukcyjnym. Oznacza to, że jako reklamodawca
            określasz maksymalny budżet kampanii oraz stawkę CPM. </p>
        <p class="subtitle">Stawka CPM </p>
        <p> Określa koszt za 1000 wyświetleń kampanii. Nie może być niższa od określonej w panelu kwoty minimalnej. Wyższe
            stawki zwiększają szanse na emisję na wybranych powierzchniach reklamowych oraz dotarcie do większej liczby
            odbiorców. </p>
        <p class="subtitle"> Budżet </p>
        <p> Określa maksymalną kwotę przeznaczoną na daną kampanię. Nie może być niższy od określonego w panelu minimalnego
            budżetu. Po zrealizowaniu budżetu, kampania przestanie być emitowana. </p>
        <p> Oba parametry możesz dowolnie zwiększać w czasie trwania kampanii. </p>
    </ng-container>
    <a
        mat-flat-button
        color="primary"
        href="https://pomoc.onetads.pl"
        target="_blank"
    ><mat-icon class="icon material-icons-outlined">live_help</mat-icon>pomoc</a>
</info-box>
